"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.dataSource", ["nucont.shared"]);
require("./data-source.routes");
